/** Page copies can exceed fetch keepalive's shared 64KB body budget. */
export async function sendSnapshot(endpoint: string, body: string): Promise<boolean> {
  try {
    const response = await fetch(endpoint, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body,
    });
    return response.ok;
  } catch { return false; }
}

/** Return an acknowledged page version, never a fabricated association. */
export async function sendSnapshotId(endpoint: string, body: string): Promise<string | null> {
  try {
    const response = await fetch(endpoint, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body,
    });
    if (!response.ok) return null;
    const result = await response.json();
    return typeof result.id === 'string' && /^[a-f0-9]{24}$/i.test(result.id) ? result.id : null;
  } catch { return null; }
}
